// extracted by mini-css-extract-plugin
module.exports = {"buttonIcon":"ButtonIcon_buttonIcon__S2kjt","spin":"ButtonIcon_spin__zb4UP","transition-opacity":"ButtonIcon_transition-opacity__nfG9r"};